export default __webpack_public_path__ + "static/media/calendario.638030ec.svg";